module.exports = __webpack_public_path__ + "media/15.10a93fcb.mp3";